var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-rdct"},[(_vm.urlNotFound)?_c('h2',[_vm._v("😕 Oops! No room or cast is linked with this shortcode")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }